var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { getIsMobile } from '@office-start/device-detection-utility';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import { IDLE_VERYLOW_PRIORITY } from '@office-start/scheduler-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import React, { lazy, useMemo } from 'react';
var SupportCentralLazy = withLazyErrorBoundary(lazy(function () {
    return import(
    /*webpackChunkName: "support-central" */ '@office-start/support-central-component');
}), 'SupportCentral', {
    schedulePriority: IDLE_VERYLOW_PRIORITY,
});
export var SupportCentral = function () {
    var _a, _b, _c;
    var componentContext = useOfficeComponentContext().data;
    var userEntitlements = useUserEntitlements().data;
    var featureGates = useFeatureGates().data;
    var isMobile = useMemo(function () {
        return getIsMobile();
    }, []);
    if (isMobile ||
        !componentContext ||
        !((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.IsAdmin) ||
        !((_c = (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _b === void 0 ? void 0 : _b.supportCentralGates) === null || _c === void 0 ? void 0 : _c.supportCentralEnabled)) {
        return null;
    }
    // TODO: Refactor Support Central to fetch context on its own
    return (React.createElement(SupportCentralLazy, __assign({}, componentContext, { minimizedOffsetRight: 50 })));
};
//# sourceMappingURL=SupportCentral.js.map